<template>
    <div>
        <div class="my-4">
            <h5 class="mb-4">Currency</h5>
            <div class="flex items-center">
                <label style="min-width: 138px;" class="whitespace-nowrap pr-2">Currency List</label>
                <v-select
                    append-to-body
                    style="width: 60%; max-width: 414px;"
                    :disabled="!can_update_currency"
                    class="w-full"
                    label="currency_name"
                    :options="currencyLists"
                    name="currency_name"
                    v-validate="'required'"
                    :reduce="(item) => item.id"
                    v-model="currency_id"
                    >
                </v-select>
            </div>
        </div>
        <vs-divider />

        <div class="my-4">
            <h5>Date & Time</h5>
            <vs-row>
                <vs-col vs-lg="6" vs-sm="12" class="p-2">
                    <div class="flex items-center">
                        <label style="min-width: 130px;" class="whitespace-nowrap pr-2">Platform Time Zone</label>
                        <v-select
                            append-to-body
                            class="w-full"
                            label="location"
                :options="platformTimeZone"
                :reduce="(item) => item.timezone_id"
                name="platformzone"
                v-validate="'required'"
                v-model="platform_timezone_id"
                        ></v-select>
                    </div>
                </vs-col>
                <vs-col vs-lg="6" vs-sm="12" class="p-2">
                    <div class="flex items-center">
                        <label style="min-width: 130px;" class="whitespace-nowrap pr-2">Time Format</label>
                        <v-select
                            append-to-body
                            class="w-full"
                            label="value"
                            :options="timeFormat"
                            :reduce="(item) => item.id"
                            name="value"
                            v-validate="'required'"
                            v-model="time_format_id"
                        ></v-select>
                    </div>
                </vs-col>
                <vs-col vs-lg="6" vs-sm="12" class="p-2">
                    <div class="flex items-center">
                        <label style="min-width: 130px;" class="whitespace-nowrap pr-2">Date Format</label>
                        <v-select
                            append-to-body
                            class="w-full"
                            label="value"
                            :options="dateFormat"
                            :reduce="(item) => item.id"
                            name="value"
                            v-validate="'required'"
                            v-model="date_format_id"
                        ></v-select>
                    </div>
                </vs-col>
                <vs-col vs-lg="6" vs-sm="12" class="p-2">
                    <div class="flex items-center">
                        <label style="min-width: 130px;" class="whitespace-nowrap pr-2">Week Start</label>
                        <v-select
                            append-to-body
                            class="w-full"
                            label="value"
                :options="weekStart"
                :reduce="(item) => item.id"
                name="value"
                v-validate="'required'"
                v-model="start_day_id"
                        ></v-select>
                    </div>
                </vs-col>
            </vs-row>
        </div>
        <vs-divider />

        <vs-button class="block mx-auto" @click="saveLocalisationSettings">Update Settings</vs-button>
    </div>
</template>

<script>
import vSelect from 'vue-select'
import { GeneralMixins } from '@/mixins/generalMixins/GeneralMixins.js'


export default {
  mixins: [GeneralMixins],
  props: {
    can_update_currency:{
      default:true
    },
    currency_id:{
      default:0
    },
    time_format_id:{
      default:''
    },
    platform_timezone_id:{
      default:null
    },
    date_format_id:{
      default:''
    },
    start_day_id:{
      default:''
    },
    dateFormat:{
      default:[]
    },
    timeFormat:{
      default:[]
    },
    weekStart:{
      default:[]
    }
  },
  
  data () {
    return {

    }
  },
  components: {
    vSelect
  },
  mounted () {
    this.fetchCurrencyList()
    this.fetchPLatformTimeZone()
  },
  methods: {
    saveLocalisationSettings () {
      const payload =  {
        currency_id:this.currency_id,
        platform_timezone_id:this.platform_timezone_id,
        time_format_id:this.time_format_id,
        date_format_id:this.date_format_id,
        start_day_id:this.start_day_id

      }
      this.$emit('saveLocalisationSettings', payload)
    }
  }
}
</script>